export function StepBackCircleIcon() {
  return (
    <svg viewBox="0 0 130 130" fill="none" aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.9" cx="64.5" cy="64.5" r="64.5" fill="#202020" />
      <path d="M67.41 56.58L62.83 52L67.41 47.41L66 46L60 52L66 58L67.41 56.58Z" fill="white" />
    </svg>
  );
}
